import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";

function ProductImagesSlideshow({ product }) {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Ref for the thumbnail slider container
  const thumbSliderContainerRef = useRef(null);

  // 1) Always call the hook (unconditionally), 
  //    but do nothing if product.media doesn't exist.
  useEffect(() => {
    // If product or product.media is missing, skip the DOM manipulation
    if (!product || !product.media) {
      return;
    }

    if (thumbSliderContainerRef.current) {
      // Apply negative margins to .slick-list
      const slickList = thumbSliderContainerRef.current.querySelector(".slick-list");
      if (slickList) {
        slickList.style.margin = "0 -10px"; 
      }

      // Add horizontal padding to each slide container
      const slideDivs = thumbSliderContainerRef.current.querySelectorAll(".slick-slide > div");
      slideDivs.forEach((div) => {
        div.style.padding = "0 10px";
        div.style.boxSizing = "border-box";
      });
    }
  }, [product, currentIndex]);

  // 2) Now conditionally return null if product.media is missing
  if (!product || !product.media) {
    return null;
  }

  // Main slider settings
  const mainSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    asNavFor: nav2,
    afterChange: (index) => setCurrentIndex(index),
  };

  // Thumbnails slider settings
  const thumbSettings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    focusOnSelect: true,
    asNavFor: nav1,
    arrows: false,
  };

  return (
    <div>
      {/* MAIN SLIDER */}
      <Slider
        {...mainSettings}
        ref={(slider) => setNav1(slider)}
        style={{ marginBottom: "1rem" }}
      >
        {product.media.map((filename, index) => {
          const imagePath = `/media/${product.product_slug}/${filename}`;
          return (
            <div key={index}>
              <div style={{ position: "relative", width: "100%" }}>
                {/* 1:1 Ratio Container */}
                <div style={{ paddingTop: "100%", position: "relative" }}>
                  <img
                    src={imagePath}
                    alt={`Slide ${index}`}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </Slider>

      {/* THUMBNAILS SLIDER */}
      <div ref={thumbSliderContainerRef} style={{ position: "relative" }}>
        <Slider {...thumbSettings} ref={(slider) => setNav2(slider)}>
          {product.media.map((filename, index) => {
            const thumbPath = `/media/${product.product_slug}/${filename}`;
            return (
              <div key={index}>
                <div
                  style={{
                    position: "relative",
                    paddingTop: "100%",
                    border: currentIndex === index ? "2px solid black" : "none",
                  }}
                >
                  <img
                    src={thumbPath}
                    alt={`Thumb ${index}`}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
}

export default ProductImagesSlideshow;